import o from "../../node_modules/lodash-es/get.js";
const e = (e2) => (s) => o(e2, s, null);
export {
  e as getNullableField
};
//# sourceMappingURL=getNullableField.js.map
